module.exports = __webpack_public_path__ + "img/sankaku_12_red.1a072052.png";